import React from 'react';
import {
  Box,
  FormControlLabel,
  Switch,
  TextField,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const DripScheduleConfig = ({ schedule, onScheduleChange, timezones, timezoneComponent }) => {
  const handleChange = (field) => (event) => {
    onScheduleChange({
      ...schedule,
      [field]: event.target.value
    });
  };

  const handleSwitchChange = (field) => (event) => {
    onScheduleChange({
      ...schedule,
      [field]: event.target.checked
    });
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Schedule Settings
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          {timezoneComponent}
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={schedule.business_hours_only}
                onChange={handleSwitchChange('business_hours_only')}
              />
            }
            label="Send only during business hours"
          />
        </Grid>

        {schedule.business_hours_only && (
          <>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Start Time"
                type="time"
                value={schedule.start_time}
                onChange={handleChange('start_time')}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }} // 5 min
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="End Time"
                type="time"
                value={schedule.end_time}
                onChange={handleChange('end_time')}
                InputLabelProps={{ shrink: true }}
                inputProps={{ step: 300 }} // 5 min
              />
            </Grid>
          </>
        )}

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={schedule.exclude_weekends}
                onChange={handleSwitchChange('exclude_weekends')}
              />
            }
            label="Exclude weekends"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DripScheduleConfig; 